module.exports = __webpack_public_path__ + "img/1689.c4c6e09e.png";